import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '@/store/index';
import { setProfile } from '@/store/slices/profile/profileSlice';
import { setProfileStepNo } from '@/store/slices/profile/profileStepNo';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { keyForCodeForSection } from '@/pages/timeline/sections/timeline/timelineSections/constants'

import { getUserProfileApiCall, getUgListApiCall } from '@/services/api';
import { verifyFieldNames } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants/index'
import MiniNav from '@/components/common/miniNav/miniNav'
import ProfileMainView from '@/pages/profile/main/view'

import '@/styles/commonContainer.css'
import './style.css'
import { setUgDegreeList } from '@/store/slices/profile/ugDegreeListSlice';
import { allPaths } from "@/constants/urlPaths"
import Footer from '@/components/common/footer';
import { addCurrentThemeClassToEle, sanitizeUrlsForBudketOldLinks } from '@/utils';
import { oldS3BucketLink } from '@/constants/apiPaths';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';

export default function ProfileMain() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const sourceComingFrom = location.state?.source;
    const navInitFromTimeline = location.state?.navInitFromTimeline;

    const purchaseId = location.state?.purchaseId;
    const { profile } = useLocalTranslation();

    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);
    const ugDegreeList = useSelector((state: RootState) => state.ugDegreeListReducer.ugDegreeList);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    const { topSafeComponent } = useSafeAreaInsets();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!sourceComingFrom) {
            navigate(allPaths.dashboard);
        }
    }, [sourceComingFrom, navigate])

    useEffect(() => {
        // reseting the stepNo so sections starts from begining
        dispatch(setProfileStepNo(0))
        manageApiCalls()
    }, []);

    useEffect(() => {
        handleIsLoadingState()
    }, [profileDetails, ugDegreeList])


    useEffect(() => {
        /*
        Return to timeline page:
        Condition for basicDetailsStatus :  
            When steps is 6
            6 is the length of componentMap in @/pages/profile/sections/basicDetails/main/view.tsx
        Condition from legalInfoStatus :  
            When steps is 1
            1 Because there is only 1 step
        Condition from addressDetailsStatus are written in /@pages/profile/sections/addressDetails/main/index.tsx
        Condition for bssDetailsStatus :
            12 is the last step hence redirect...
        */
        let doRedirect = false
        if (sourceComingFrom === verifyFieldNames.basicDetailsStatus && profileStepNo > 6) {
            doRedirect = true
        } else if (sourceComingFrom === verifyFieldNames.legalInfoStatus && profileStepNo === 1) {
            doRedirect = true
        }
        else if (sourceComingFrom === verifyFieldNames.addressDetailsStatus && profileStepNo === 3) {
            doRedirect = true
        } else if (sourceComingFrom === verifyFieldNames.idVerificationStatus) {
            if (profileDetails.isUnderGraduate === false && profileStepNo === 4) {
                doRedirect = true
            }
            if (profileDetails.isUnderGraduate === true && profileStepNo === 8) {
                doRedirect = true
            }
        } else if (sourceComingFrom === verifyFieldNames.bssDetailsStatus) {
            if (profileStepNo === 12) {
                doRedirect = true
            }
        }

        if (doRedirect) {
            dispatch(setProfileStepNo(0))
            // debugger
            let source = keyForCodeForSection.verify
            if (navInitFromTimeline) {
                source = navInitFromTimeline
            }
            navigate(`/timeline/${purchaseId}`, {
                state: {
                    source: source,
                },
            });
        }
    }, [profileStepNo])

    // useEffect(() => {
    //     if (!toastVisible) {
    //         showToast()
    //     }
    // }, [])

    const manageApiCalls = () => {
        if (Object.entries(profileDetails).length === 0) {
            getProfileDetails();
        }
        if ((sourceComingFrom === verifyFieldNames.bssDetailsStatus
            || sourceComingFrom === verifyFieldNames.idVerificationStatus
        )
            && Object.entries(ugDegreeList).length === 0) {
            getUgDegreeList();
        }
    }




    const getUgDegreeList = async () => {
        const ugDegreeList = await getUgListApiCall();
        if (ugDegreeList.data && ugDegreeList.status) {
            dispatch(setUgDegreeList(ugDegreeList.data));
        }
    }


    const getProfileDetails = async () => {
        const profileDetails = await getUserProfileApiCall();
        if (profileDetails.data && profileDetails.status) {            
            // console.log("profileDetails : ", profileDetails.data)
            const sanitizedProfileDetails = sanitizeUrlsForBudketOldLinks(profileDetails.data, oldS3BucketLink)
            // console.log("sanitizedProfileDetails : ", sanitizedProfileDetails)
            dispatch(setProfile(sanitizedProfileDetails));
        }
    }

    const handleIsLoadingState = () => {
        let makeIsLoadingFalse = false
        if (sourceComingFrom === verifyFieldNames.basicDetailsStatus
            || sourceComingFrom === verifyFieldNames.legalInfoStatus
            || sourceComingFrom === verifyFieldNames.addressDetailsStatus) {
            if (Object.entries(profileDetails).length > 0) {
                makeIsLoadingFalse = true
            }
        }
        else if (sourceComingFrom === verifyFieldNames.bssDetailsStatus
            || sourceComingFrom === verifyFieldNames.idVerificationStatus
        ) {
            if (Object.entries(profileDetails).length > 0
                && Object.entries(ugDegreeList).length > 0) {
                makeIsLoadingFalse = true
            }
        }

        if (makeIsLoadingFalse) {
            setIsLoading(false)
        }
    }

    const handleRedirectFromMiniNav = () => {
        let stepsToMinus = 1
        /*
        This if condition is to skip email verification if email is not changed 
        4 is the index where the Dob Component is there in @/pages/profile/sections/basicDetails/main/view.tsx -> componentMap
        So when back button is pressed from Dob Component it should land to email section thats why - 2
        */
        if ((sourceComingFrom && sourceComingFrom === verifyFieldNames.basicDetailsStatus)
            && profileStepNo === 4) {
            stepsToMinus = stepsToMinus + 1
        }
        let profileStepNoTemp = profileStepNo - stepsToMinus
        dispatch(setProfileStepNo(profileStepNoTemp))

        if (profileStepNoTemp < 0) {
            // debugger
            let source = ""
            if (navInitFromTimeline) {
                source = navInitFromTimeline
            }
            else if (sourceComingFrom
                && (
                    sourceComingFrom === verifyFieldNames.basicDetailsStatus
                    || sourceComingFrom === verifyFieldNames.legalInfoStatus
                    || sourceComingFrom === verifyFieldNames.addressDetailsStatus
                    || sourceComingFrom === verifyFieldNames.idVerificationStatus
                    || sourceComingFrom === verifyFieldNames.bssDetailsStatus
                    || sourceComingFrom === verifyFieldNames.profileVerifyStatus
                )
            ) {
                source = keyForCodeForSection.verify
            }

            navigate(`/timeline/${purchaseId}`, {
                state: {
                    source: source,
                },
            });
        }
    }

    return (
        <div
            className={`font-roboto profileIndex 
                 ${addCurrentThemeClassToEle(currentTheme, 'profileIndex')}`}>

            <MiniNav
                navItemName={profile.heading}
                redirectTo={handleRedirectFromMiniNav}
            />

            {/* 54px is the height is mini nav bar 
                28px is the pt as per figma
            */}
            <div className='commonContainer mt-[40px] pt-[28px] pb-[30px]'>
                
                <ProfileMainView
                    isLoading={isLoading}
                    sourceComingFrom={sourceComingFrom}
                />
            </div>

            {/* <Footer /> */}

        </div>
    );
}
